import { defineMessages } from 'react-intl';

export default defineMessages({
  resultsPerPage: {
    id: 'resultsPerPage',
    defaultMessage: 'Results per page',
  },
  resultsPerPageSeparator: {
    id: 'resultsPerPageSeparator',
    defaultMessage: 'of {totalItems}',
  },
});
